import { getStore } from '../../../../init-store';
import { AppInfoReport } from '../../../shared/helpers/stats';
import { GRID_VIEW } from '../constants';

export const getAppInfoReport = (): AppInfoReport => {
    const {
        ua,
        call: {
            record: { isRecording },
            screenSharing: { desktopSharingStatus },
            videoGrid: { activeGridView },
        },
    } = getStore().getState();
    let platform: AppInfoReport['platform'];
    switch (ua.OSFamily) {
        case 'MacOS':
            platform = 'mac';
            break;
        case 'Windows':
            platform = 'win';
            break;
        case 'Linux':
            platform = 'lin';
            break;
        default:
            platform = ua.OSFamily;
    }
    return {
        platform,
        recording: !!isRecording,
        screencast: desktopSharingStatus === 'local',
        speakerLayout: activeGridView === GRID_VIEW.PRESENTER,
        vbg: false,
    };
};
